import React from "react";
import IconClose from "../Resources/svg/Icons/IconClose";
import IconWarning from "../Resources/svg/Icons/IconWarning";
import Button from "./FormElements/Button";

export default function ModalRetakeAsessory({
  open,
  setOpen,
  type,
  message,
  callbackClosed,
  title,
  subtitle,
  investmentProfile,
  registerDate,
  firstButtonText,
  secondButtonText,
  firstButtonFunction,
  secondButtonFunction,
  subtitleMessage,
  messageAlert,
}) {
  const handleClose = () => {
    setOpen(false);
    if (callbackClosed && type === "success") {
      callbackClosed();
    }
  };

  return (
    <div
      className={
        "modal-filtering modal-result is-midle-error" + (open ? " is-open" : "")
      }
    >
      <div className={"modal-filtering__box"}>
        <div className="modal-filtering__close" onClick={handleClose}>
          <IconClose />
        </div>
        <div className="modal-filtering__body">
          <div className="wrap">
            <div className="modal-filtering__inner">
              <div className="modal-result__icon--warning">
                <IconWarning />
              </div>
              <h2 className="modal-result__title">{title}</h2>
              <div className="modal-result__desc">
                {subtitle && subtitle} {subtitleMessage && subtitleMessage}{" "}
                <span style={{textTransform: 'uppercase'}}>{investmentProfile && investmentProfile}</span>
                {messageAlert && messageAlert} {registerDate && registerDate}
              </div>
              <div className="actions">
                {secondButtonText && (
                  <Button
                    className="btn  actions__continue"
                    onClick={secondButtonFunction}
                  >
                    {secondButtonText}
                  </Button>
                )}
                {firstButtonText && (
                  <Button
                    className="btn is-secondary actions__cancel"
                    onClick={firstButtonFunction}
                  >
                    {firstButtonText}
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
